import React, { useState, useLayoutEffect } from 'react'
import  ModalButtonAdmission from './ModalButtonAdmission'
import Button from '../../shared/Button/Button'
import Icon from '../../shared/Icon/Icon'
import './ModalButtonAdmission.scss'

const ButtonAdmission = ({ career }) => {

  // Variable para controlar la apertura o cierre del modal
  const [ modalButton, setModalButton ] = useState(false);

  const openModal = () => {
    setModalButton(true);
  };
  
  const closeModal = () => {
    setModalButton(false);
  };

  useLayoutEffect(() => {
    const body = document.getElementsByTagName('body')
    body[0].setAttribute('class', 'fix-internalpages-without-header')

    return () => {
      body[0].removeAttribute('class', 'fix-internalpages-without-header')
    }
  })

  // Configuramos el boton segun las opciones del componente Button
  const buttonLink = {
    iconButton: {
      code: "fa-graduation-cap",
      type: "fas"
    },
    button: {
      label: "INSCRIBITE AHORA",
      url: career.inscriptionLink
    },
    customButton: {
      shape: "rectangle",
      size: "big",
      variant: "secondary"
    }
  }

  const buttonLinkDistance = {
    iconButton: {
      code: "fa-graduation-cap",
      type: "fas"
    },
    button: {
      label: "INSCRIBITE AHORA",
      url: career.inscriptionLinkDistance
    },
    customButton: {
      shape: "rectangle",
      size: "big",
      variant: "secondary"
    }
  }

  return (
    <div className="">
      {career.inscriptionLink && career.inscriptionLinkDistance ? (
        <div className='my-5 d-flex justify-content-center'>
          <button
            className='d-flex btn-admission'
            onClick={() => openModal()}
          >
            <Icon style={{ marginRight: '.5em' }} {...{code: "fa-graduation-cap", type: "fas"}}/>
            INSCRIBITE AHORA
          </button>
        </div>
      ) : (
        (career.inscriptionLink ?
          <Button
            key={`buttonId-${career.id}`}
            button={buttonLink.button}
            customButton={buttonLink.customButton}
            icon={buttonLink.iconButton}
            matchPages={[]}
          ></Button>
          :
          career.inscriptionLinkDistance ?
            <Button
              key={`buttonId-${career.id}`}
              button={buttonLinkDistance.button}
              customButton={buttonLinkDistance.customButton}
              icon={buttonLinkDistance.iconButton}
              matchPages={[]}
            ></Button>
            : 
            null
        )
      )}
      {modalButton && ( <ModalButtonAdmission career={career} onClose={closeModal}></ModalButtonAdmission>)}
    </div>
  )
}

export default ButtonAdmission